import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleField, LabelWithHelp } from '../../../components';
import { Field, useFormikContext } from 'formik';

interface TrashRetentionFormProps {}

function TrashRetentionForm(_props: TrashRetentionFormProps) {
    const { t } = useTranslation();
    const { values } = useFormikContext<AnyObj>();
    const enabled = !!values?.trash_retention?.enabled;

    return (
        <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 space-x-0 lg:space-x-12">
            <div className="flex-1">
                <h2 className="mt-4 mb-1 text-base font-semibold leadin text-lg text-gray-900 dark:text-gray-100">
                    {t('settings.trash_retention')}
                </h2>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                    {t('settings.trash_retention_desc')}
                </p>
                <div className="mt-5">
                    <div className="mt-2 flex space-between">
                        <label className="flex-1 text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                            {t('settings.enable_trash_retention')}
                        </label>
                        <ToggleField name="trash_retention.enabled" />
                    </div>
                </div>
                <div className={`mt-5 ${enabled ? '' : 'opacity-50 pointer-events-none'}`}>
                    <LabelWithHelp htmlFor="trash_retention_value" help={t('settings.help.trash_retention') || ''}>
                        {t('settings.trash_retention_keep_for')}
                    </LabelWithHelp>
                    <div className="mt-2 flex gap-2">
                        <Field
                            type="number"
                            min="1"
                            step="1"
                            id="trash_retention_value"
                            name="trash_retention.value"
                            className="block w-28 rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                        <Field
                            as="select"
                            name="trash_retention.unit"
                            className="block w-40 rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        >
                            <option value="days">{t('settings.trash_retention_unit_days')}</option>
                            <option value="months">{t('settings.trash_retention_unit_months')}</option>
                            <option value="years">{t('settings.trash_retention_unit_years')}</option>
                        </Field>
                    </div>
                    <small className="text-gray-500 dark:text-gray-400">{t('settings.trash_retention_keep_for_desc')}</small>
                </div>
            </div>
        </div>
    );
}

export default TrashRetentionForm;
